import { CpsNotificationProps } from '@cs-cms/types';
import { createContext } from 'react';
import { NotificationCenterItem } from '../types/NotificationCenterItem';

export interface INotificationContext {
  showToast: (props: Omit<CpsNotificationProps, 'show'>) => void;
  toastNotification: CpsNotificationProps | null;
  centerNotifications: NotificationCenterItem[];
  addCenterNotification: (notification: NotificationCenterItem) => void;
  updateCenterNotification: (notificationId: string, updates: Partial<NotificationCenterItem>) => void;
  removeCenterNotification: (notificationId: string) => void;
  markAllAsRead: () => void;
  clearAllCenterNotifications: () => void;
  unreadCenterCount: number;
}

export const NotificationContext = createContext<INotificationContext | undefined>(undefined);
